module.exports = __webpack_public_path__ + "static/media/NameSmile.bbd33b84.otf";